import { render, staticRenderFns } from "./IconUp.vue?vue&type=template&id=428c3016&"
import script from "./IconUp.vue?vue&type=script&lang=js&"
export * from "./IconUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports